export type DateValue = Date | string | null | undefined;

export const convertToValidDate = (value: DateValue): Date | undefined => {
    if (!value) {
        return undefined;
    }

    const date = value instanceof Date ? value : new Date(value);
    return Number.isNaN(date.getTime()) ? undefined : date;
};
